import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const steps = [{
  num: "1",
  title: "Upload your panel layout or nameplate schedule",
  desc: "DXF, DWG, AI, PDF, or SVG, or a nameplate/legend list."
}, {
  num: "2",
  title: "Get a quote",
  desc: "Materials, sizes, mounting, quantity pricing, lead time, and rush options."
}, {
  num: "3",
  title: "Approve the proof",
  desc: "Confirm nameplate data, ratings text, legends, and layout in writing before engraving."
}, {
  num: "4",
  title: "Production & ship",
  desc: "Engraved on the specified materials and shipped install-ready; approved layouts stored for repeat builds."
}];
export default function HowToOrder() {
  return <section id="how-to-order" className="bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-20">
          <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground mb-6 tracking-tight">
            How Do Panel Builders Order From Evermark?
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            Ordering panel marking from Evermark Industrial Solutions takes four steps, built around your drawing and a proof.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {steps.map((step, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center relative">
              {}
              {i < steps.length - 1 && <div className="hidden lg:block absolute top-12 left-[60%] w-[80%] h-px bg-border" aria-hidden="true" />}
              
              <div className="mb-6 relative z-10 bg-background px-4">
                <span className="font-default text-6xl md:text-7xl font-bold text-primary leading-none">
                  {step.num}
                </span>
              </div>
              
              <h3 className="font-default text-xl font-semibold text-foreground mb-3">
                {step.title}
              </h3>
              
              <p className="text-muted-foreground font-sans text-sm md:text-base leading-relaxed">
                {step.desc}
              </p>
            </div>)}
        </div>

        <div className="mt-16 md:mt-20 flex justify-center">
          <Button asChild size="lg" className="px-8 py-6 text-lg font-semibold">
            <Link to="/ContactPage">
              Request a Quote
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}